import React from 'react';
import styles from './Label.module.scss';

export const Label: React.FC<{
  label: React.ReactNode | string;
  className?: string;
  childrenClassName?: string;
  children?: React.ReactNode | string;
}> = (props) => {
  const { label, children, className, childrenClassName } = props;
  return (
    <div className={styles.labelBox + ` ${className || ''}`}>
      <span className={styles.label}>{label}</span>
      <div className={childrenClassName}>{children}</div>
    </div>
  );
};
